import React from "react";
import logo from "../images/nkennei-bg.png";
const LogoSection = ({ altText = "Nkenne Ai Logo" }) => {
  return (
    <div className="flex items-center justify-start min-w-[250px] h-[64px]">
      <img src={logo} alt={altText} className="w-96 h-96 object-contain mr-4" />
    </div>
  );
};

export default LogoSection;
